import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
// import desktopImage from '../../../assets/images/backoffice/akasha/akasha.png';
// import mobileImage from '../../../assets/images/backoffice/akasha/akashaMobile.png';
import desktopPowerPacksImage from '../../../assets/images/backoffice/powerPacks/powerPacksPageBanner.png';
import mobilePowerPacksImage from '../../../assets/images/backoffice/powerPacks/powerPacksPageBannerMobile.png';
import { AnimatedDashboard } from '../../../components/animation/AnimatedDashboard';
import Spinner from '../../../components/common/Spinner';
import { getUserTickets } from '../../../slices/auth-slice';
import { P1, P3 } from '../../../styles/FontStyles';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { SidebarModal } from '../../../components';
import { SETTINGS_VIRTUAL_OFFICE } from '../../../routes/routes';

import { Desktop, Mobile } from '../../Kyc/KycStyled';
import { getPowerPacksHubs } from '../Marketplace.actions';

import {
  USDT,
  formatUSDNoDecimals,
  dateDifferenceInDaysFromToday
} from '../../../helpers/helperFunctions';

import { PurchasePackageAndCombo } from '../PurchasePackageAndCombo/PurchasePackageAndCombo';

import {
  GridItem,
  AkashaTitle,
  PackagesTitle,
  Separator,
  MustHaveLicenceText,
  AkashaPackageH2
} from './PowerPacks.styled';

export const PowerPacks = () => {
  const dispatch = useDispatch();

  const history = useHistory();

  const { loading, hubs } = useSelector((state) => state.marketplace);
  const { user } = useSelector((state) => state.auth.userInfo);

  useEffect(() => {
    dispatch(getPowerPacksHubs());
    dispatch(getUserTickets());
  }, [dispatch]);

  const [selectedHub, setSelectedHub] = useState(hubs?.[0] || null);
  const [modal, setModal] = useState(false);
  const [modalLicence, setModalLicence] = useState(false);

  const handleSeeDetails = (hub) => {
    setSelectedHub(hub);
  };

  const handleSelectPackage = (hub) => {
    const date = user?.currentVirtualOfficeLicence?.dateEnd;

    const dateEnded = dateDifferenceInDaysFromToday(date) === 0;
    if (dateEnded) {
      setModalLicence(true);
    } else {
      setModal(true);
      handleSeeDetails(hub);
    }
  };

  const renderPowerPacksBanner = () => {
    return (
      <>
        <Desktop>
          <section style={{ position: 'relative' }}>
            <img
              src={desktopPowerPacksImage}
              alt='trading'
              style={{ width: '100%' }}
            />
          </section>
        </Desktop>

        <Mobile>
          <section style={{ position: 'relative' }}>
            <img
              src={mobilePowerPacksImage}
              alt='trading'
              style={{ width: '100%' }}
            />
          </section>
        </Mobile>
      </>
    );
  };
  useEffect(() => {
    setSelectedHub(hubs?.[0]);
  }, [hubs]);

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'marketplace'}>
      {renderPowerPacksBanner()}
      <AkashaTitle>
        Get ready to supercharge your business with our brand-new Power Packs!
      </AkashaTitle>

      <P1 mb='40' mt='20'>
        {' '}
        We’ve bundled everything you need to succeed into one easy, unbeatable
        offer.
        <b>
          {' '}
          Each pack includes a high-value Supernode, a 1 or 2 Year FinUp Trading
          AI License, and your own Virtual or Physical FlipMe Card.
        </b>{' '}
        This is your all-in-one solution to start faster, trade smarter, and
        grow your income with less hassle.
      </P1>

      <P1 mb='40' mt='20'>
        These Power Packs were designed to make your life easier and your
        business more profitable. No more buying separate products or worrying
        about missing essential tools. We’ve put together the ultimate package
        so you can focus on building, sharing, and earning—while enjoying
        tremendous savings over buying everything separately. It’s everything
        you need in one place, at one amazing price.
      </P1>

      <P1 mb='40' mt='20'>
        Choose the Power Pack that fits your goals and get instant access to
        premium tools and resources that set you apart. Whether you’re just
        getting started or ready to scale to the next level, there’s a Power
        Pack designed for you
      </P1>

      <PackagesTitle>Select Your Power Pack</PackagesTitle>

      <Flexed wrap rowSM gap='24px' justifyCenter>
        {hubs.map((hub, index) => (
          <GridItem
            key={index}
            selected={selectedHub?.packageId === hub?.packageId}
            onClick={() => handleSeeDetails(hub)}>
            <img src={hub.image} style={{ width: '100%' }} />

            <Flexed column center>
              <AkashaPackageH2 mb='4' mt='30'>
                {formatUSDNoDecimals(hub.price)} {USDT}
              </AkashaPackageH2>
            </Flexed>
            <P1
              mb='12'
              color={'#2074A8'}
              bold
              style={{ textDecoration: 'line-through' }}>
              {formatUSDNoDecimals(hub?.details?.oldPrice)} {USDT}
            </P1>
            <Separator />

            <Flexed between>
              <P1 mb='12' color='#233866' bold>
                {hub?.details?.items?.superNode?.name}
              </P1>
              <P1 color={'#4F6DB7'} bold>
                {formatUSDNoDecimals(hub?.details?.items?.superNode?.price)}{' '}
                <span style={{ color: '#4F6DB7', fontSize: 14 }}>{USDT}</span>
              </P1>
            </Flexed>

            <Flexed between>
              <P1 mb='12' bold color='#233866'>
                {hub?.details?.items?.flipme?.name}
              </P1>
              <P1 color={'#4F6DB7'} bold>
                {formatUSDNoDecimals(hub?.details?.items?.flipme?.price)}{' '}
                <span style={{ color: '#4F6DB7', fontSize: 14 }}>{USDT}</span>
              </P1>
            </Flexed>

            {hub?.details?.items?.finup?.name ? (
              <Flexed between>
                <P1 mb='12' bold color='#233866'>
                  {hub?.details?.items?.finup?.name}
                </P1>

                <P1 color={'#4F6DB7'} bold>
                  {formatUSDNoDecimals(hub?.details?.items?.finup?.price)}{' '}
                  {hub?.details?.items?.finup?.price && (
                    <span style={{ color: '#4F6DB7', fontSize: 14 }}>
                      {USDT}
                    </span>
                  )}
                </P1>
              </Flexed>
            ) : (
              <Flexed between>
                <P1
                  mb='12'
                  bold
                  color={
                    selectedHub?.packageId === hub?.packageId
                      ? '#F2F6FF'
                      : '#FFFFFF'
                  }>
                  M
                </P1>

                <P1 bold></P1>
              </Flexed>
            )}

            <Button
              color='#007FFF'
              borderColor='#007FFF'
              w='200px'
              wSM='100%'
              mt='20'
              onClick={() => handleSelectPackage(hub)}
              negative={true}>
              Select Power Pack
            </Button>
          </GridItem>
        ))}
      </Flexed>

      <MustHaveLicenceText
        style={{ cursor: 'pointer' }}
        onClick={() => history.push(SETTINGS_VIRTUAL_OFFICE)}>
        Must have active Back Office Subscription
      </MustHaveLicenceText>

      <PurchasePackageAndCombo
        selectedPackage={selectedHub}
        modal={modal}
        setModal={setModal}
      />

      <SidebarModal
        isOpen={modalLicence}
        setOpen={() => {
          setModalLicence(!modalLicence);
        }}
        title={'You Need an Active BO  Subscription'}
        sidebarWidth={'560px'}>
        <Flexed column center>
          {' '}
          <P1 center bold mt='80'>
            To purchase Power Packs, you must first have an active Back Office
            Subscription
          </P1>
          <Button
            w='auto'
            p='0 20px 0 20px'
            mt='40'
            onClick={() => history.push(SETTINGS_VIRTUAL_OFFICE)}>
            Buy Back Office subscription
          </Button>
        </Flexed>
      </SidebarModal>
    </AnimatedDashboard>
  );
};
